import { modalStore } from '@core/modal'
import { getStateThunkValues, type TBaseAsyncAction } from '@core/store'

import { type TSessionDialogId } from '../constants/sessionDialogIds'
import { sessionDialogStore } from './sessionDialogStore'

type TSessionDialogClaim = {
    id: TSessionDialogId
    show: () => void
}

export const claimSessionDialogSlot: TBaseAsyncAction<TSessionDialogClaim> =
    ({ id, show }) =>
    (dispatch, getState) => {
        const [activeDialog] = getStateThunkValues([modalStore.props.getActiveDialog], getState)

        if (activeDialog !== null) {
            dispatch(sessionDialogStore.actions.defer(id))

            return
        }

        dispatch(sessionDialogStore.actions.markExhausted())
        show()
    }
